import ViewProfileListGlobal from "../Components/Global/ViewProfileListGlobal";
import TaskDetails from "../Page/Owner/Task/TaskDetails";
import Requestlist from "../Page/Tenant/Requestlist";
import Tenantdashboard from "../Page/Tenant/Tenantdashboard";
import TaskView from "../Page/Worker/TaskView";
import WorkerDashboard from "../Page/Worker/WorkerDashobard";

export const TenantRoutes = [
  {
    path: "/tenantdashboard",
    Component: (
      <Tenantdashboard allowedRoles={["Tenant"]} key="tenantdashboard" />
    ),
    Title: "Tenantdashboard",
  },
  {
    path: "/requestlist",
    Component: <Requestlist allowedRoles={["Tenant"]} key="requestlist" />,
    Title: "Requestlist",
  },
  {
    path: "/tenant-tasklist",
    Component: (
      <ViewProfileListGlobal allowedRoles={["Tenant"]} key="enant-tasklist" />
    ),
    Title: "TenantTaskList",
  },
  {
    path: "tenant/task-details/:id",
    Component: (
      <TaskDetails allowedRoles={["Tenant"]} key="enant-tasklist444" />
    ),
    Title: "TenantTaskList",
  },
];

export const WorkerRoutes = [
  {
    path: "/workerdashboard",
    Component: (
      <WorkerDashboard allowedRoles={["Worker"]} key="workerdashboard" />
    ),
    Title: "WorkerDashboard",
  },
  {
    path: "/worker-tasklist/:id",
    Component: <TaskView allowedRoles={["Worker"]} key="worker" />,
    Title: "TaskView",
  },
];
